module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('row', [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-info-box', {
    attrs: {
      "bgColor": "bg-aqua",
      "bgIcon": "ion ion-ios-gear-outline",
      "text": "Messages",
      "number": "1410",
      "numberType": "comma"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-info-box', {
    attrs: {
      "bgColor": "bg-green",
      "bgIcon": "fa fa-flag-o",
      "text": "Bookmarks",
      "number": "410",
      "numberType": "comma"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-info-box', {
    attrs: {
      "bgColor": "bg-yellow",
      "bgIcon": "fa fa-files-o",
      "text": "Uploads",
      "number": "13648",
      "numberType": "comma"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-info-box', {
    attrs: {
      "bgColor": "bg-red",
      "bgIcon": "fa fa-star-o",
      "text": "Likes",
      "number": "93139",
      "numberType": "comma"
    }
  })], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-info-box', {
    attrs: {
      "wrapBgColor": "bg-aqua",
      "bgIcon": "fa fa-bookmark-o",
      "text": "Bookmarks",
      "number": "41410",
      "numberType": "comma",
      "isProgress": true,
      "percentage": 70,
      "progressDescription": "70% Increase in 30 Days"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-info-box', {
    attrs: {
      "wrapBgColor": "bg-green",
      "bgIcon": "fa fa-thumbs-o-up",
      "text": "Likes",
      "number": "41410",
      "numberType": "comma",
      "isProgress": true,
      "percentage": 70,
      "progressDescription": "70% Increase in 30 Days"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-info-box', {
    attrs: {
      "wrapBgColor": "bg-yellow",
      "bgIcon": "fa fa-calendar",
      "text": "Events",
      "number": "41410",
      "numberType": "comma",
      "isProgress": true,
      "percentage": 70,
      "progressDescription": "70% Increase in 30 Days"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-info-box', {
    attrs: {
      "wrapBgColor": "bg-red",
      "bgIcon": "fa fa-comments-o",
      "text": "Comments",
      "number": "41410",
      "numberType": "comma",
      "isProgress": true,
      "percentage": 70,
      "progressDescription": "70% Increase in 30 Days"
    }
  })], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-small-box', {
    attrs: {
      "color": "aqua",
      "icon": "ion-bag",
      "title": "150",
      "description": "New Order",
      "moreText": "More info"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-small-box', {
    attrs: {
      "color": "green",
      "icon": "ion-stats-bars",
      "title": "53%",
      "description": "Bounce Rate",
      "moreText": "More info"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-small-box', {
    attrs: {
      "color": "yellow",
      "icon": "ion-person-add",
      "title": "44",
      "description": "User Registrations",
      "moreText": "More info"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-small-box', {
    attrs: {
      "color": "red",
      "icon": "ion-pie-graph",
      "title": "65",
      "description": "Unique Visitors",
      "moreText": "More info"
    }
  })], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-box', {
    attrs: {
      "theme": "box-default",
      "title": "Expandable",
      "isOpen": false
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v("\n          The body of the box\n        ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-box', {
    attrs: {
      "theme": "box-success",
      "title": "Expandable"
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v("\n          The body of the box\n        ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-box', {
    attrs: {
      "theme": "box-warning",
      "title": "Expandable"
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v("\n          The body of the box\n        ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-box', {
    attrs: {
      "theme": "box-danger",
      "title": "Expandable",
      "isLoading": true
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v("\n          The body of the box\n        ")])])], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-box', {
    attrs: {
      "theme": "box-default",
      "isSolid": true,
      "title": "Expandable",
      "isOpen": false
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v("\n          The body of the box\n        ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-box', {
    attrs: {
      "theme": "box-success",
      "isSolid": true,
      "title": "Expandable"
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v("\n          The body of the box\n        ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-box', {
    attrs: {
      "theme": "box-warning",
      "isSolid": true,
      "title": "Expandable"
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v("\n          The body of the box\n        ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('va-box', {
    attrs: {
      "theme": "box-danger",
      "isSolid": true,
      "title": "Expandable",
      "isLoading": true
    }
  }, [_c('div', {
    slot: "The body of the box"
  }, [_vm._v("\n          The body of the box\n        ")])])], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-3 col-sm6 col-xs-12"
  }, [_c('va-direct-chat', {
    attrs: {
      "theme": "primary",
      "talkList": _vm.talkList,
      "contacts": _vm.contacts,
      "title": "Direct Chat",
      "badgeCount": 3,
      "placeholder": "내용을 입력하세요..."
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm6 col-xs-12"
  }, [_c('va-direct-chat', {
    attrs: {
      "theme": "success",
      "talkList": _vm.talkList,
      "contacts": _vm.contacts,
      "title": "Direct Chat",
      "badgeCount": 3,
      "placeholder": "내용을 입력하세요..."
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm6 col-xs-12"
  }, [_c('va-direct-chat', {
    attrs: {
      "theme": "warning",
      "talkList": _vm.talkList,
      "contacts": _vm.contacts,
      "title": "Direct Chat",
      "badgeCount": 3,
      "placeholder": "내용을 입력하세요..."
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm6 col-xs-12"
  }, [_c('va-direct-chat', {
    attrs: {
      "theme": "danger",
      "talkList": _vm.talkList,
      "contacts": _vm.contacts,
      "title": "Direct Chat",
      "badgeCount": 3,
      "placeholder": "내용을 입력하세요..."
    }
  })], 1)]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Social Widgets")]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('va-social-user-v2', {
    attrs: {
      "name": "Nadia Carmichael",
      "description": "Lead Developer",
      "profileImage": "/static/img/user7-128x128.jpg",
      "list": _vm.socialDataList[0]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('va-social-user-v1', {
    attrs: {
      "name": "Alexander Pierce",
      "description": "Founder & CEO",
      "profileImage": "/static/img/user1-128x128.jpg",
      "infoList": _vm.socialDataList[1]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('va-social-user-v1', {
    attrs: {
      "name": "Elizabeth Pierce",
      "description": "Web Designer",
      "profileImage": "/static/img/user3-128x128.jpg",
      "infoList": _vm.socialDataList[2],
      "isBackgroundImage": true
    }
  })], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-6"
  }, [_c('va-social-box', {
    attrs: {
      "name": _vm.socialBoxList[0].name,
      "description": _vm.socialBoxList[0].description,
      "profileImage": _vm.socialBoxList[0].profileImage,
      "images": _vm.socialBoxList[0].images,
      "text": _vm.socialBoxList[0].text,
      "buttons": _vm.socialBoxList[0].buttons,
      "likeCount": _vm.socialBoxList[0].likeCount,
      "commentCount": _vm.socialBoxList[0].commentCount,
      "comments": _vm.socialBoxList[0].comments
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('va-social-box', {
    attrs: {
      "name": _vm.socialBoxList[1].name,
      "description": _vm.socialBoxList[1].description,
      "profileImage": _vm.socialBoxList[1].profileImage,
      "text": _vm.socialBoxList[1].text,
      "buttons": _vm.socialBoxList[1].buttons,
      "likeCount": _vm.socialBoxList[1].likeCount,
      "commentCount": _vm.socialBoxList[1].commentCount,
      "comments": _vm.socialBoxList[1].comments,
      "attachments": _vm.socialBoxList[1].attachments
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e9b11d1a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/examples/WidgetsExample.vue
// module id = 544
// module chunks = 1